import styled from '@emotion/styled'
import { color, font, size } from '../../styles'
import SVG from '../../assets/svg'
import { padding } from '../../styles/size'
import LoadingSpinner from './LoadingSpinner'

interface Props {
   label: string
   content: string | JSX.Element
   icon?: React.ReactNode
   linkLabel: string
   onClick?: () => void
   isContentClickable?: boolean
   linkIcon: 'arrow' | 'gear' | undefined
   className?: string
   loading?: boolean
}

const Card: React.FC<Props> = ({
   label,
   content,
   icon,
   linkLabel,
   onClick,
   isContentClickable,
   linkIcon,
   className,
   loading,
}) => {
   return (
      <Holder onClick={() => !isContentClickable && onClick?.()} className={className}>
         <div className="card-label">
            <h3>{label}</h3>
            {(icon || loading) && (
               <span className="card-icon">
                  {loading ? (
                     <LoadingSpinner type="drops" color={color.green} className="spinner" />
                  ) : (
                     icon
                  )}
               </span>
            )}
         </div>
         <div className={'card-content ' + (isContentClickable ? 'is-clickable' : '')}>
            {content}
         </div>
         <div className="card-link_label">
            <span>{linkLabel}</span>
            <span className="card-link_icon">
               {linkIcon === 'arrow' && <SVG.form.arrowRight />}

               {linkIcon === 'gear' && <SVG.form.settings />}
            </span>
         </div>
      </Holder>
   )
}

const Holder = styled.div`
   --background-color: #ffffff;
   display: flex;
   flex-direction: column;
   border-radius: 1em;
   border: 1px solid #e7e7e7;
   background-color: var(--background-color);
   padding: ${padding.block} ${padding.block};
   overflow: hidden;
   cursor: pointer;
   transition: all 0.2s ease-in-out;
   row-gap: 1em;
   column-gap: 1.7em;
   box-sizing: border-box;
   isolation: isolate;
   --holder-background-color: var(--background-color);

   &:hover {
      box-shadow: 0px 0px 3px 1px #e7e7e7a6;
      --background-color: #f6f6f6;
   }

   .card-content {
      position: relative;
      ${font.thin};
      color: ${color.grayDark};
      grid-column: 1/3;
      grid-row: 2;
      z-index: 2;
      flex: 100%;

      &.is-clickable {
         pointer-events: all !important;
         user-select: all !important;
      }
   }

   .card-label {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .card-icon {
         display: flex;
         align-items: center;
         justify-content: center;
         background-color: #eff0f2;
         border-radius: 50%;
         padding: 0.7em;
         width: 2.5em;
         height: 2.5em;
         svg {
            width: 85%;
            height: 85%;
         }
         .spinner {
            width: 1.5em;
            height: 1.5em;
         }
      }
   }
   .card-link_label {
      font-size: ${size.m};
      color: ${color.blue};
      border-top: 1px solid #e7e7e7;
      padding-top: calc(${padding.block} / 1.5);
      display: flex;
      align-items: center;
      pointer-events: none;
      user-select: none;
      width: 100%;
      span {
         ${font.regular};
         color: inherit;
         margin: 0;
         padding: 0;
      }
      .card-link_icon {
         margin-left: 1em;
         display: flex;
         align-items: center;
         justify-content: center;
         svg {
            width: 1.1em;
            height: 1.1em;
            fill: ${color.blue};
         }
      }
   }
`
export type { Props as CardProps }
export default Card
